module.exports = __webpack_public_path__ + "static/media/logo.bce28fb7.svg";